module.exports = __webpack_public_path__ + "static/media/berkeley.76dac212.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/berkeley.jpg
// module id = 111
// module chunks = 0